export const ON_SUBMIT_FEEDBACK_REQUEST = 'ON_SUBMIT_FEEDBACK_REQUEST';
export const ON_SUBMIT_FEEDBACK_SUCCESS = 'ON_SUBMIT_FEEDBACK_SUCCESS';
export const ON_SUBMIT_FEEDBACK_FAILURE = 'ON_SUBMIT_FEEDBACK_FAILURE';
export const DELETE_MERCHANT_SUGGESTION_REQUEST = 'DELETE_MERCHANT_SUGGESTION_REQUEST';
export const DELETE_MERCHANT_SUGGESTION_SUCCESS = 'DELETE_MERCHANT_SUGGESTION_SUCCESS';
export const DELETE_MERCHANT_SUGGESTION_FAILURE = 'DELETE_MERCHANT_SUGGESTION_FAILURE';
export const LIST_MERCHANT_SUGGESTION_APPLICABLE_TRANSACTIONS_REQUEST = 'LIST_MERCHANT_SUGGESTION_APPLICABLE_TRANSACTIONS_REQUEST';
export const LIST_MERCHANT_SUGGESTION_APPLICABLE_TRANSACTIONS_SUCCESS = 'LIST_MERCHANT_SUGGESTION_APPLICABLE_TRANSACTIONS_SUCCESS';
export const LIST_MERCHANT_SUGGESTION_APPLICABLE_TRANSACTIONS_FAILURE = 'LIST_MERCHANT_SUGGESTION_APPLICABLE_TRANSACTIONS_FAILURE';
export const SET_TRANSACTIONS_REQUESTING = 'SET_TRANSACTIONS_REQUESTING';
export const TRANSACTIONS_REQUEST = 'TRANSACTIONS_REQUEST';
export const TRANSACTIONS_SUCCESS = 'TRANSACTIONS_SUCCESS';
export const TRANSACTIONS_FAILURE = 'TRANSACTIONS_FAILURE';
export const SEARCH_TRANSACTIONS_REQUEST = 'SEARCH_TRANSACTIONS_REQUEST';
export const SEARCH_TRANSACTIONS_SUCCESS = 'SEARCH_TRANSACTIONS_SUCCESS';
export const SEARCH_TRANSACTIONS_FAILURE = 'SEARCH_TRANSACTIONS_FAILURE';
export const LINKED_TRANSACTION_REQUEST = 'LINKED_TRANSACTION_REQUEST';
export const LINKED_TRANSACTION_SUCCESS = 'LINKED_TRANSACTION_SUCCESS';
export const LINKED_TRANSACTION_FAILURE = 'LINKED_TRANSACTION_FAILURE';
export const GET_ORIGINAL_TRANSACTION_REQUEST = 'GET_ORIGINAL_TRANSACTION_REQUEST';
export const GET_ORIGINAL_TRANSACTION_SUCCESS = 'GET_ORIGINAL_TRANSACTION_SUCCESS';
export const GET_ORIGINAL_TRANSACTION_FAILURE = 'GET_ORIGINAL_TRANSACTION_FAILURE';
export const SIMILAR_TRANSACTIONS_REQUEST = 'SIMILAR_TRANSACTIONS_REQUEST';
export const SIMILAR_TRANSACTIONS_SUCCESS = 'SIMILAR_TRANSACTIONS_SUCCESS';
export const SIMILAR_TRANSACTIONS_FAILURE = 'SIMILAR_TRANSACTIONS_FAILURE';
export const RESET_SIMILAR_TRANSACTIONS = 'RESET_SIMILAR_TRANSACTIONS';
export const IS_FETCHING_BANK_TRANSACTIONS = 'IS_FETCHING_BANK_TRANSACTIONS';
export const RESET_TRANSACTION = 'RESET_TRANSACTION';
export const SAVE_NOTE_REQUEST = 'SAVE_NOTE_REQUEST';
export const SAVE_NOTE_SUCCESS = 'SAVE_NOTE_SUCCESS';
export const SAVE_NOTE_FAILURE = 'SAVE_NOTE_FAILURE';
export const GET_TAGS_REQUEST = 'GET_TAGS_REQUEST';
export const GET_TAGS_SUCCESS = 'GET_TAGS_SUCCESS';
export const GET_TAGS_FAILURE = 'GET_TAGS_FAILURE';
export const SET_TAGS_REQUEST = 'SET_TAGS_REQUEST';
export const SET_TAGS_SUCCESS = 'SET_TAGS_SUCCESS';
export const SET_TAGS_FAILURE = 'SET_TAGS_FAILURE';
export const CHANGE_DATE_TRANSACTION_REQUEST = 'CHANGE_DATE_TRANSACTION_REQUEST';
export const CHANGE_DATE_TRANSACTION_SUCCESS = 'CHANGE_DATE_TRANSACTION_SUCCESS';
export const CHANGE_DATE_TRANSACTION_FAILURE = 'CHANGE_DATE_TRANSACTION_FAILURE';
export const RENAME_TRANSACTION_REQUEST = 'RENAME_TRANSACTION_REQUEST';
export const RENAME_TRANSACTION_SUCCESS = 'RENAME_TRANSACTION_SUCCESS';
export const RENAME_TRANSACTION_FAILURE = 'RENAME_TRANSACTION_FAILURE';
export const EDIT_TRANSACTION_AMOUNT_REQUEST = 'EDIT_TRANSACTION_AMOUNT_REQUEST';
export const EDIT_TRANSACTION_AMOUNT_SUCCESS = 'EDIT_TRANSACTION_AMOUNT_SUCCESS';
export const EDIT_TRANSACTION_AMOUNT_FAILURE = 'EDIT_TRANSACTION_AMOUNT_FAILURE';
export const DELETE_TRANSACTION_REQUEST = 'DELETE_TRANSACTION_REQUEST';
export const DELETE_TRANSACTION_SUCCESS = 'DELETE_TRANSACTION_SUCCESS';
export const DELETE_TRANSACTION_FAILURE = 'DELETE_TRANSACTION_FAILURE';
export const CREATE_TRANSACTION_REQUEST = 'CREATE_TRANSACTION_REQUEST';
export const CREATE_TRANSACTION_SUCCESS = 'CREATE_TRANSACTION_SUCCESS';
export const CREATE_TRANSACTION_FAILURE = 'CREATE_TRANSACTION_FAILURE';
export const GET_TRANSACTION_REQUEST = 'GET_TRANSACTION_REQUEST';
export const GET_TRANSACTION_SUCCESS = 'GET_TRANSACTION_SUCCESS';
export const GET_TRANSACTION_FAILURE = 'GET_TRANSACTION_FAILURE';
export const ADD_TRANSACTION_TO_CACHE = 'ADD_TRANSACTION_TO_CACHE';
export const GET_MERCHANT_STATS_REQUEST = 'GET_MERCHANT_STATS_REQUEST';
export const GET_MERCHANT_STATS_SUCCESS = 'GET_MERCHANT_STATS_SUCCESS';
export const GET_MERCHANT_STATS_FAILURE = 'GET_MERCHANT_STATS_FAILURE';
export const GET_RECEIPTS_REQUEST = 'GET_RECEIPTS_REQUEST';
export const GET_RECEIPTS_SUCCESS = 'GET_RECEIPTS_SUCCESS';
export const GET_RECEIPTS_FAILURE = 'GET_RECEIPTS_FAILURE';
export const DELETE_RECEIPT_REQUEST = 'DELETE_RECEIPT_REQUEST';
export const DELETE_RECEIPT_SUCCESS = 'DELETE_RECEIPT_SUCCESS';
export const DELETE_RECEIPT_FAILURE = 'DELETE_RECEIPT_FAILURE';
export const UPLOAD_RECEIPT_REQUEST = 'UPLOAD_RECEIPT_REQUEST';
export const UPLOAD_RECEIPT_SUCCESS = 'UPLOAD_RECEIPT_SUCCESS';
export const UPLOAD_RECEIPT_FAILURE = 'UPLOAD_RECEIPT_FAILURE';
export const SPLIT_TRANSACTION_REQUEST = 'SPLIT_TRANSACTION_REQUEST';
export const SPLIT_TRANSACTION_SUCCESS = 'SPLIT_TRANSACTION_SUCCESS';
export const SPLIT_TRANSACTION_FAILURE = 'SPLIT_TRANSACTION_FAILURE';
export const UNSPLIT_TRANSACTION_REQUEST = 'UNSPLIT_TRANSACTION_REQUEST';
export const UNSPLIT_TRANSACTION_SUCCESS = 'UNSPLIT_TRANSACTION_SUCCESS';
export const UNSPLIT_TRANSACTION_FAILURE = 'UNSPLIT_TRANSACTION_FAILURE';
export const SET_SPENDING_GROUP_INFO_SUCCESS = 'SET_SPENDING_GROUP_INFO_SUCCESS';
export const TRANSACTION_SCHEDULES_REQUEST = 'TRANSACTION_SCHEDULES_REQUEST';
export const TRANSACTION_SCHEDULES_SUCCESS = 'TRANSACTION_SCHEDULES_SUCCESS';
export const TRANSACTION_SCHEDULES_FAILURE = 'TRANSACTION_SCHEDULES_FAILURE';
export const CREATE_TRANSACTION_SCHEDULE_REQUEST = 'CREATE_TRANSACTION_SCHEDULE_REQUEST';
export const CREATE_TRANSACTION_SCHEDULE_SUCCESS = 'CREATE_TRANSACTION_SCHEDULE_SUCCESS';
export const CREATE_TRANSACTION_SCHEDULE_FAILURE = 'CREATE_TRANSACTION_SCHEDULE_FAILURE';
export const UPDATE_TRANSACTION_SCHEDULE_REQUEST = 'UPDATE_TRANSACTION_SCHEDULE_REQUEST';
export const UPDATE_TRANSACTION_SCHEDULE_SUCCESS = 'UPDATE_TRANSACTION_SCHEDULE_SUCCESS';
export const UPDATE_TRANSACTION_SCHEDULE_FAILURE = 'UPDATE_TRANSACTION_SCHEDULE_FAILURE';
export const DELETE_TRANSACTION_SCHEDULE_REQUEST = 'DELETE_TRANSACTION_SCHEDULE_REQUEST';
export const DELETE_TRANSACTION_SCHEDULE_SUCCESS = 'DELETE_TRANSACTION_SCHEDULE_SUCCESS';
export const DELETE_TRANSACTION_SCHEDULE_FAILURE = 'DELETE_TRANSACTION_SCHEDULE_FAILURE';
export const SCHEDULED_TRANSACTIONS_REQUEST = 'SCHEDULED_TRANSACTIONS_REQUEST';
export const SCHEDULED_TRANSACTIONS_SUCCESS = 'SCHEDULED_TRANSACTIONS_SUCCESS';
export const SCHEDULED_TRANSACTIONS_FAILURE = 'SCHEDULED_TRANSACTIONS_FAILURE';
export const GET_TRANSACTIONS_UPLOAD_URL_REQUEST = 'GET_TRANSACTIONS_UPLOAD_URL_REQUEST';
export const GET_TRANSACTIONS_UPLOAD_URL_SUCCESS = 'GET_TRANSACTIONS_UPLOAD_URL_SUCCESS';
export const GET_TRANSACTIONS_UPLOAD_URL_FAILURE = 'GET_TRANSACTIONS_UPLOAD_URL_FAILURE';
export const GET_TRANSACTIONS_CONFIG_REQUEST = 'GET_TRANSACTIONS_CONFIG_REQUEST';
export const GET_TRANSACTIONS_CONFIG_SUCCESS = 'GET_TRANSACTIONS_CONFIG_SUCCESS';
export const GET_TRANSACTIONS_CONFIG_FAILURE = 'GET_TRANSACTIONS_CONFIG_FAILURE';
export const PROCESS_TRANSACTIONS_REQUEST = 'PROCESS_TRANSACTIONS_REQUEST';
export const PROCESS_TRANSACTIONS_SUCCESS = 'PROCESS_TRANSACTIONS_SUCCESS';
export const PROCESS_TRANSACTIONS_FAILURE = 'PROCESS_TRANSACTIONS_FAILURE';
export const REFRESH_TRANSACTIONS_CATEGORY_REQUEST = 'REFRESH_TRANSACTIONS_CATEGORY_REQUEST';
export const REFRESH_TRANSACTIONS_CATEGORY_SUCCESS = 'REFRESH_TRANSACTIONS_CATEGORY_SUCCESS';
export const REFRESH_TRANSACTIONS_CATEGORY_FAILURE = 'REFRESH_TRANSACTIONS_CATEGORY_FAILURE';
